module.exports = __webpack_public_path__ + "img/01.e4d615bd.png";